var map = {
	"./excel.svg-files-sprite": "tWX2",
	"./generic.svg-files-sprite": "xVkb",
	"./image.svg-files-sprite": "qsUk",
	"./link.svg-files-sprite": "GWR1",
	"./pdf.svg-files-sprite": "Zalc",
	"./powerpoint.svg-files-sprite": "D4SX",
	"./word.svg-files-sprite": "H1ds"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NSUl";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/icons/files ^\.\/.*\.svg\-files\-sprite$
// module id = NSUl
// module chunks = 0